import { render, staticRenderFns } from "./ProductEditActions.vue?vue&type=template&id=f3b557ae"
import script from "./ProductEditActions.vue?vue&type=script&lang=js"
export * from "./ProductEditActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports